export const defaultFormDisabled = {
  loja: false,
  produto: true,
};

export const defaultTipoAjuste = {
  label: undefined,
  value: undefined,
  tipo_operacao: undefined,
};
